<script>
export default {
  name: 'regiatration',
  components: {},
  data () {
    return {
      surveyLoading: true,
      surveyData: [],
      groupedUserSurveyData: {
        KlimaSurveyEconomy: [],
        KlimaSurveySocial: [],
        KlimaSurveyEnvironment: [],
        KlimaSurveyFag: []
      },
      appointmentId: ''
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    var urlStr = window.location.href
    var url = new URL(urlStr.replace('/#', ''))
    var searchParams = url.searchParams
    var contactId = searchParams.get('contactId')
    this.contactId = contactId
    var appointmentId = searchParams.get('appointmentId')
    this.appointmentId = appointmentId
    this.getUserSurvey()
  },
  methods: {
    getUserSurvey () {
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        parameters: JSON.stringify({
          operation: 'getUserSurvey',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            for (var economy in res.data.main[0].economy) {
              this.surveyId = res.data.main[0].klimasurveryId
              if (res.data.main[0].economy[economy].value === '1') {
                this.groupedUserSurveyData.KlimaSurveyEconomy.push(
                  {
                    typeId: res.data.main[0].economy[economy].economicId,
                    title: res.data.main[0].economy[economy].title,
                    value: res.data.main[0].economy[economy].value
                  })
              }
            }
            for (var social in res.data.main[0].social) {
              if (res.data.main[0].social[social].value === '1') {
                this.groupedUserSurveyData.KlimaSurveySocial.push(
                  {
                    typeId: res.data.main[0].social[social].socialId,
                    title: res.data.main[0].social[social].title,
                    value: res.data.main[0].social[social].value
                  })
              }
            }
            for (var environment in res.data.main[0].environment) {
              if (res.data.main[0].environment[environment].value === '1') {
                this.groupedUserSurveyData.KlimaSurveyEnvironment.push(
                  {
                    typeId: res.data.main[0].environment[environment].environmentId,
                    title: res.data.main[0].environment[environment].title,
                    value: res.data.main[0].environment[environment].value
                  })
              }
            }
            for (var fag in res.data.main[0].fag) {
              this.groupedUserSurveyData.KlimaSurveyFag.push(
                {
                  typeId: res.data.main[0].fag[fag].fagId,
                  title: res.data.main[0].fag[fag].title,
                  value: res.data.main[0].fag[fag].value
                })
            }
            this.surveyLoading = false
          } else {
            this.$toastr('error', 'Error in getUserSurvey()')
          }
        },
        response => {
          this.$toastr('error', 'Error in getUserSurvey()')
        }
      )
      this.surveyLoading = true
    },
    radioChanged (typeId) {
      var inputVal = document.querySelector('#fag-' + typeId + ' label.el-radio-button.is-focus').id.split('-')
      for (var l = 0; l < this.groupedUserSurveyData['KlimaSurveyFag'].length; l++) {
        if (this.groupedUserSurveyData['KlimaSurveyFag'][l].typeId === typeId) {
          this.groupedUserSurveyData['KlimaSurveyFag'][l].value = inputVal[1]
        }
      }
    },
    saveUserSurvey () {
      var economy = []
      for (var x = 0; x < this.groupedUserSurveyData['KlimaSurveyEconomy'].length; x++) {
        var economyId = this.groupedUserSurveyData['KlimaSurveyEconomy'][x].typeId
        var economyTitle = this.groupedUserSurveyData['KlimaSurveyEconomy'][x].title
        var economyValue = this.groupedUserSurveyData['KlimaSurveyEconomy'][x].value
        economy.push(
          {
            usereconomyId: 0,
            economyId: parseInt(economyId),
            title: economyTitle,
            value: parseInt(economyValue)
          })
      }
      var social = []
      for (var j = 0; j < this.groupedUserSurveyData['KlimaSurveySocial'].length; j++) {
        var socialId = this.groupedUserSurveyData['KlimaSurveySocial'][j].typeId
        var socialTitle = this.groupedUserSurveyData['KlimaSurveySocial'][j].title
        var socialValue = this.groupedUserSurveyData['KlimaSurveySocial'][j].value
        social.push(
          {
            usersocialId: 0,
            socialId: parseInt(socialId),
            title: socialTitle,
            value: parseInt(socialValue)
          })
      }
      var environment = []
      for (var k = 0; k < this.groupedUserSurveyData['KlimaSurveyEnvironment'].length; k++) {
        var environmentId = this.groupedUserSurveyData['KlimaSurveyEnvironment'][k].typeId
        var environmentTitle = this.groupedUserSurveyData['KlimaSurveyEnvironment'][k].title
        var environmentValue = this.groupedUserSurveyData['KlimaSurveyEnvironment'][k].value
        environment.push(
          {
            usersocialId: 0,
            environmentId: parseInt(environmentId),
            title: environmentTitle,
            value: parseInt(environmentValue)
          })
      }
      var fag = []
      for (var l = 0; l < this.groupedUserSurveyData['KlimaSurveyFag'].length; l++) {
        var fagId = this.groupedUserSurveyData['KlimaSurveyFag'][l].typeId
        var fagTitle = this.groupedUserSurveyData['KlimaSurveyFag'][l].title
        var fagValue = this.groupedUserSurveyData['KlimaSurveyFag'][l].value
        fag.push(
          {
            userfagId: 0,
            fagId: parseInt(fagId),
            title: fagTitle,
            value: parseInt(fagValue)
          })
      }

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        parameters: JSON.stringify({
          klimasurveryId: this.surveyId,
          operation: 'addSurvey',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          economy: economy,
          social: social,
          environment: environment,
          fag: fag
        })
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.surveyLoading = false
            this.$toastr('success', 'Opdateret')
          } else {
            this.$toastr('error', 'Error in saveUserSurvey()')
          }
        },
        response => {
          this.$toastr('error', 'Error in saveUserSurvey()')
        }
      )
      this.surveyLoading = true
    },
    gotoSurvey () {
      this.$router.push('/klima/survey?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId)
    }
  },
  computed: {}
}
</script>
<template>
  <div class="animated fadeIn">
    <!-- mobile view -->
    <div class="col-12 lg-col-4 md-col-9 py3 mb4 shadow mx-auto">
      <!-- back button -->
      <div @click="gotoSurvey()" class="clearfix primarycolor flex justify-start items-center pointer">
        <span class="mr1"><i class="el-icon-back"></i></span>
        <span class="h5 gibson line-height-1 m0 p0">Tilbage</span>
      </div>
      <div class="py2"></div>
      <!-- category -->
      <div class="clearfix px3 py4 highlights relative">
        <div class="absolute center top-0 left-0 right-0" style="top:-16px;">
          <img src="static/svg/h.svg" width="36" height="36" alt="" />
        </div>
        <div class="clearfix" v-if="surveyLoading">
          <div class="col-12">
            <div class="loader"></div>
          </div>
        </div>
        <div v-else>
          <p class="h4 gibson regular center primarycolor line-height-1">
            Oprettelse
          </p>
          <div class="py2"></div>
          <p class="h3 regular center gibson darkblue line-height-3">
            Hvilke fag er med i din klimaentreprise?
          </p>
          <div class="py2"></div>
          <!-- fag container -->
          <div :id="'fag-' + fag.typeId" class="clearfix mb3" v-for="(fag, index) in groupedUserSurveyData['KlimaSurveyFag']" :key="index">
            <p class="h3 center primarycolor gibson line-height-1 mb3">
              {{fag.title}}
            </p>
            <!-- radio groups for industries -->
            <div class="flex justify-center items-center">
              <el-radio-group value="Ikke med"" v-if="fag.value === '0'" @change="radioChanged(fag.typeId)">
                <el-radio-button id="val-0" :name="'radio-' + index" label="Ikke med"></el-radio-button>
                <el-radio-button id="val-1" :name="'radio-' + index" label="Hoved"></el-radio-button>
                <el-radio-button id="val-2" :name="'radio-' + index" label="Fag"></el-radio-button>
              </el-radio-group>
              <el-radio-group value="Hoved"" v-else-if="fag.value === '1'" @change="radioChanged(fag.typeId)">
                <el-radio-button id="val-0" :name="'radio-' + index" label="Ikke med"></el-radio-button>
                <el-radio-button id="val-1" :name="'radio-' + index" label="Hoved"></el-radio-button>
                <el-radio-button id="val-2" :name="'radio-' + index" label="Fag"></el-radio-button>
              </el-radio-group>
              <el-radio-group value="Fag"" v-else-if="fag.value === '2'" @change="radioChanged(fag.typeId)">
                <el-radio-button id="val-0" :name="'radio-' + index" label="Ikke med"></el-radio-button>
                <el-radio-button id="val-1" :name="'radio-' + index" label="Hoved"></el-radio-button>
                <el-radio-button id="val-2" :name="'radio-' + index" label="Fag"></el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <!-- save button -->
          <button class="col-6 mx-auto action-button h4 my3 regular flex justify-center items-center gibson line-height-1 p2" @click="saveUserSurvey()">
            <span>Gem</span><span class="pl1"><i class="el-icon-right"></i></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less">
.progress {
  background-color: rgba(178, 190, 195, 0.6);
}
.el-radio-button__inner {
  font-size:17.5px;
  border-color: rgb(25, 163, 192);
  color: rgb(25, 163, 192);
  font-family: 'canada-type-gibson';
  font-weight: 600;
  border-width: 2px;
}
.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background-color: rgba(77, 207, 85, 1.0);
  border-color: rgba(77, 207, 85, 1.0);
  box-shadow: none;
}
.el-radio-button:first-child .el-radio-button__inner {
  border-left: 2px solid rgb(25, 163, 192);
}
.loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>


// WEBPACK FOOTER //
// registration.vue?5a7bc32e